import { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Button, Alert } from 'react-bootstrap';

const MFASetup = () => {
  const [secret, setSecret] = useState('');
  const [qrCode, setQrCode] = useState('');
  const [showModal, setShowModal] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    loadMFASetup();
  }, []);

  const loadMFASetup = async () => {
    try {
      const response = await fetch('/api/admin/setup-mfa');
      const data = await response.json();

      if (data.success) {
        setSecret(data.manualEntryKey);
        setQrCode(data.qrCode);
      } else {
        setError(data.error || 'Failed to load MFA setup');
      }
    } catch (err) {
      setError('Failed to load MFA setup');
    }
  };

  return (
    <Container className="mt-5">
      <Row className="justify-content-center">
        <Col md={8}>
          <Card>
            <Card.Header>
              <h3>MFA Setup Instructions</h3>
            </Card.Header>
            <Card.Body>
              <Alert variant="warning">
                <strong>Important:</strong> This is a one-time setup. Save the secret key securely.
              </Alert>

              {error && <Alert variant="danger">{error}</Alert>}

              {qrCode && (
                <div className="text-center mb-4">
                  <h5>Scan this QR code with Google Authenticator:</h5>
                  <div className="d-flex justify-content-center mb-3">
                    <img src={qrCode} alt="QR Code" style={{ maxWidth: '300px' }} />
                  </div>
                  <p className="text-muted">
                    Or manually enter this key: <code>{secret}</code>
                  </p>
                </div>
              )}

              <div className="mt-4">
                <h5>Steps to set up:</h5>
                <ol>
                  <li>Install Google Authenticator app on your phone</li>
                  <li>Scan the QR code above or manually enter the secret key</li>
                  <li>Save the secret key in your Vercel environment variables as <code>MFA_SECRET</code></li>
                  <li>Once configured, use the 6-digit code from the app to access the admin panel</li>
                </ol>
              </div>

              <div className="mt-4">
                <Alert variant="info">
                  <strong>Vercel Setup:</strong>
                  <br />
                  1. Go to your Vercel project settings
                  <br />
                  2. Navigate to Environment Variables
                  <br />
                  3. Add <code>MFA_SECRET</code> with value: <code>{secret}</code>
                  <br />
                  4. Also add <code>GITHUB_TOKEN</code> and <code>GITHUB_REPO</code> for file updates
                </Alert>
              </div>

              <Button variant="primary" onClick={() => setShowModal(false)}>
                I've Set This Up
              </Button>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default MFASetup;

